import { Module } from '@nestjs/common';
import { ServeStaticModule } from '@nestjs/serve-static';
import { TypeOrmModule } from '@nestjs/typeorm';
import * as fs from 'fs';
import { join } from 'path';
import { FileUploadLogEntity } from './entities/file-upload-logs.entity';
import { FileUploadEntity } from './entities/file-upload.entity';
import { FileHandlingController } from './file-handling.controller';
import { FileHandlingService } from './file-handling.service';
import { FileUploadLogRepo } from './repositories/file-upload-log.repo';
import { FileUploadRepo } from './repositories/file-upload.repo';

const filesDestination = './upload-files';
if (!fs.existsSync(filesDestination)) {
  fs.mkdirSync(filesDestination);
}

@Module({
  imports: [
    TypeOrmModule.forFeature([FileUploadEntity, FileUploadLogEntity]),
    ServeStaticModule.forRootAsync({
      useFactory: () => [
        {
          rootPath: join(__dirname, '../../../../', 'upload_files'),
          serveRoot: '/static',
          serveStaticOptions: {
            redirect: false,
            index: false,
          }, 
        },
      ],
    }),
  ],
  controllers: [FileHandlingController],
  providers: [FileHandlingService, FileUploadLogRepo, FileUploadRepo],
  exports: [FileHandlingService],
})
export class FileHandlingModule { }
